import request from '../services/request';

export function searchLocations(data, page) {
  return request({
    url: `/location/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function search(data) {
  return request({
    url: `/location/search`,
    method: 'POST',
    data,
  });
}

export function storeLocation(data) {
  return request({
    url: `/location`,
    method: 'POST',
    data,
  });
}

export function statusLocation(id, data) {
  return request({
    url: `/location/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function updateLocation(id, data) {
  return request({
    url: `/location/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteLocation(id) {
  return request({
    url: `/location/${id}`,
    method: 'DELETE',
  });
}

export function getLocationById(id) {
  return request({
    url: `/location/${id}`,
    method: 'GET',
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/location/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

// -------------- Catalogos para combobox ------------------------

export function catalogCompanies() {
  return request({
    url: `/location/catalog/companies`,
    method: 'GET',
  });
}
